export default "__VITE_ASSET__DyBgxU72__"